/* Krissy Noel Studio — Dogwood theme script.
   Progressive enhancement only: every form on the site still works with
   JavaScript disabled (it falls back to normal Shopify form posts). */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = (Number(cents) / 100);
    var amount = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', '#').replace(/,/g, '.').replace('#', ','))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function toast(html) {
    var el = $('#CartToast');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 4500);
  }

  function setCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  /* ---------- Mobile menu drawer ---------- */
  function initDrawer() {
    var toggle = $('[data-menu-open]');
    var drawer = $('#MenuDrawer');
    if (!toggle || !drawer) return;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = $('a, button', drawer.querySelector('.drawer__panel'));
      if (first) first.focus();
    }
    function close() {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    toggle.addEventListener('click', open);
    $all('[data-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    var main = $('[data-gallery-main]', root);
    if (!main) return;
    $all('[data-gallery-thumb]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = main.querySelector('img');
        if (!img) return;
        img.src = btn.dataset.src;
        img.srcset = btn.dataset.srcset || '';
        img.alt = btn.dataset.alt || '';
        $all('[data-gallery-thumb]', root).forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariantPicker(root) {
    var dataEl = $('[data-product-json]', root);
    var form = $('form[data-product-form]', root);
    if (!dataEl || !form) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = $('input[name="id"]', form);
    var button = $('[data-add-button]', form);
    var priceEl = $('[data-price]', root);
    var statusEl = $('[data-availability]', root);
    var moneyFormat = root.dataset.moneyFormat;

    function selected() {
      return $all('fieldset[data-option-index]', root).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selected();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) {
        button.disabled = true;
        button.textContent = button.dataset.unavailableText;
        return;
      }
      idInput.value = variant.id;
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.addText : button.dataset.soldText;
      if (statusEl) statusEl.classList.toggle('product__oneofone--sold', !variant.available);
      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(variant.price, moneyFormat) + '</span>';
        if (variant.compare_at_price > variant.price) html += ' <s>' + formatMoney(variant.compare_at_price, moneyFormat) + '</s>';
        priceEl.innerHTML = html;
        priceEl.classList.toggle('price--sale', variant.compare_at_price > variant.price);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    $all('fieldset[data-option-index] input', root).forEach(function (input) {
      input.addEventListener('change', update);
    });
  }

  /* ---------- Alteration add-on ---------- */
  function alterationPayload(form) {
    var box = $('[data-alteration]', form);
    var toggle = box && $('[data-alteration-toggle]', box);
    if (!toggle || !toggle.checked) return null;
    var notesEl = $('[data-alteration-notes]', box);
    var notes = notesEl ? notesEl.value.trim() : '';
    var props = { 'For': box.dataset.alterationFor };
    if (notes) props['Measurements'] = notes;
    return { items: [{ id: Number(box.dataset.alterationVariant), quantity: 1, properties: props }] };
  }
  function toggleAlteration(input) {
    var box = input.closest('[data-alteration]');
    var details = box && $('[data-alteration-details]', box);
    if (details) details.hidden = !input.checked;
    var form = input.closest('form');
    var express = form && $('[data-dynamic-checkout]', form);
    if (express) express.hidden = input.checked;
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-alteration-toggle]')) toggleAlteration(e.target);
  });

  /* ---------- AJAX add to cart ---------- */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-product-form]')) return;
      if (!window.fetch) return;
      e.preventDefault();
      var button = $('[data-add-button]', form);
      var original = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = button.dataset.addingText || '…'; }
      fetch(routes + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) {
            toast(res.body.description || res.body.message || 'That piece could not be added.');
            return;
          }
          var alteration = alterationPayload(form);
          var next = alteration
            ? fetch(routes + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(alteration)
              }).then(function (r) {
                if (!r.ok) toast('The piece was added, but the alteration could not be. Please email me.');
                var t = $('[data-alteration-toggle]', form); if (t) { t.checked = false; toggleAlteration(t); }
              })
            : Promise.resolve();
          return next.then(function () { return fetch(routes + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              setCartCount(cart.item_count);
              var labels = button ? button.dataset : {};
              toast((labels.addedText || 'Added to your bag.') + ' <a href="' + routes + 'cart">' + (labels.viewCartText || 'View bag') + '</a>');
            });
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (button) { button.disabled = false; button.textContent = original; } });
    });
  }

  /* ---------- Cart page quantity + remove ---------- */
  function initCart() {
    var cart = $('[data-cart]');
    if (!cart || !window.fetch) return;
    function change(line, quantity) {
      cart.setAttribute('aria-busy', 'true');
      return fetch(routes + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (b) { toast(b.description || b.message || 'Could not update your bag.'); });
        window.location.reload();
      }).finally(function () { cart.removeAttribute('aria-busy'); });
    }
    cart.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-remove-line]');
      if (remove) { e.preventDefault(); change(Number(remove.dataset.removeLine), 0); return; }
      var step = e.target.closest('[data-qty-step]');
      if (step) {
        e.preventDefault();
        var input = $('input', step.closest('.qty'));
        var next = Math.max(0, Number(input.value) + Number(step.dataset.qtyStep));
        change(Number(input.dataset.line), next);
      }
    });
  }

  /* ---------- Drop countdown ---------- */
  function initCountdowns() {
    $all('[data-countdown]').forEach(function (el) {
      var target = Date.parse(el.dataset.countdown);
      if (isNaN(target)) { el.hidden = true; return; }
      var parts = {
        d: $('[data-unit="d"]', el), h: $('[data-unit="h"]', el),
        m: $('[data-unit="m"]', el), s: $('[data-unit="s"]', el)
      };
      var done = el.parentNode.querySelector('[data-countdown-done]');
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          el.hidden = true;
          if (done) done.hidden = false;
          clearInterval(timer);
          return;
        }
        var s = Math.floor(diff / 1000);
        parts.d.textContent = Math.floor(s / 86400);
        parts.h.textContent = pad(Math.floor(s % 86400 / 3600));
        parts.m.textContent = pad(Math.floor(s % 3600 / 60));
        parts.s.textContent = pad(s % 60);
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    $all('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  function init() {
    initDrawer();
    $all('[data-product-root]').forEach(function (root) { initGallery(root); initVariantPicker(root); });
    initAddToCart();
    initCart();
    initCountdowns();
    initSort();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Exposed for the test suite (tests/theme_js.test.mjs).
  window.KNS = { formatMoney: formatMoney };
})();
